import type OpenSeadragon from 'openseadragon';

export const ZOOM_FACTOR = 1.9;

export const DEFAULT_OSD_OPTIONS: Partial<OpenSeadragon.Options> = {
  showNavigationControl: false,
  gestureSettingsMouse: { clickToZoom: false, dblClickToZoom: false },
  visibilityRatio: 1,
  minZoomImageRatio: 0.6,
  constrainDuringPan: true,
  drawer: 'canvas',
};
